import React, {useCallback} from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import _isEmpty from 'lodash/isEmpty';
import {useTranslation} from 'react-i18next';
import {useSettingsStyles} from '../userProperties';
import {useAccordionStyles} from '../../../../pages/centralPage/userPreferences/accordionStyles';
import {
  // accordionClasses,
  FormControl,
  // FormControlLabel,
  FormLabel,
  IconButton,
  // Radio,
  // RadioGroup,
  Typography,
} from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
// import CheckCircleIcon from '@mui/icons-material/CheckCircle';
// import FiberManualRecordOutlinedIcon from '@mui/icons-material/FiberManualRecordOutlined';
// import {getConsultantName} from '../../../../pages/centralPage/helper';
// import _capitalize from 'lodash/capitalize';

const SelectedUserSpecialties = ({ selectedSpecialties, onDeleteSpecialty, onChangeActiveSpecialty }) => {
  const { t } = useTranslation();
  const classes = useSettingsStyles();
  // const accordionClasses = useAccordionStyles();

  // const getSpecialtyName = useCallback((specialty) => {
  //   if (specialty) {
  //     return (
  //       <Typography variant='subtitle2' sx={{ pt: .5 }} fontWeight={400}>
  //         {_capitalize(specialty?.__description || 'UNK')}
  //       </Typography>
  //     );
  //   }
  // }, []);

  return (
    <>
      <FormControl sx={{ mt: 2, mb: 1 }} style={{ width: '100%' }}>
        <FormLabel style={{fontSize: 'small'}}>
          {t('User Specialties')}
        </FormLabel>

        <div className={classes.divRow} style={{gap: 10, marginTop: 5}}>
          {!_isEmpty(selectedSpecialties) && selectedSpecialties.map(spec => (
            <div
              key={spec?.__id}
              className={clsx(classes.specIcon, spec?.isActive && 'active')}
              onClick={(e) => onChangeActiveSpecialty(e, spec)}
            >
              {spec?.__description || 'UNK'}

              <IconButton
                size="small"
                onClick={() => onDeleteSpecialty(spec)}
                className="disabled-options"
                disabled={spec?.isActive}
              >
                <ClearIcon style={{fontSize: 16}}/>
              </IconButton>
            </div>
          ))}
        </div>
      </FormControl>

      {/*TODO: Proper handling changing this option. To rethink if could be here or only in default admission consultant modal.*/}
      {/*<FormControl sx={{ mt: 2, mb: 1 }}>*/}
      {/*  <FormLabel style={{fontSize: 'small'}}>*/}
      {/*    {t('Default Admitting Clinician Specialty')}*/}
      {/*  </FormLabel>*/}

      {/*  <RadioGroup*/}
      {/*    // value={selectedValue}*/}
      {/*    // onChange={onSelectConsultant}*/}
      {/*  >*/}
      {/*    {!_isEmpty(selectedSpecialties) && selectedSpecialties.map((specialty, specialtyIdx) => (*/}
      {/*      <FormControlLabel*/}
      {/*        key={specialtyIdx}*/}
      {/*        style={{height: 45}}*/}
      {/*        value={specialty?.__id}*/}
      {/*        label={getSpecialtyName(specialty)}*/}
      {/*        control={*/}
      {/*          <Radio*/}
      {/*            checkedIcon={<CheckCircleIcon />}*/}
      {/*            icon={<FiberManualRecordOutlinedIcon className={accordionClasses.emptyCheckbox} />}*/}
      {/*          />*/}
      {/*        }*/}
      {/*      />*/}
      {/*    ))}*/}
      {/*  </RadioGroup>*/}
      {/*</FormControl>*/}
    </>
  )
}

SelectedUserSpecialties.defaultProps = {
  selectedSpecialties: [],
}

SelectedUserSpecialties.propTypes = {
  selectedSpecialties: PropTypes.array.isRequired,
  onDeleteSpecialty: PropTypes.func,
  onChangeActiveSpecialty: PropTypes.func,
}

export default SelectedUserSpecialties;